var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg003Alert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8944 3.78885C12.7977 3.59532 12.6407 3.4384 12.4472 3.34163C11.9532 3.09464 11.3526 3.29487 11.1056 3.78885L2.72361 20.5528C2.65419 20.6916 2.61804 20.8447 2.61804 21C2.61804 21.5523 3.06576 22 3.61804 22H20.382C20.5372 22 20.6903 21.9638 20.8292 21.8944C21.3232 21.6474 21.5234 21.0468 21.2764 20.5528L12.8944 3.78885ZM5.23601 19.999L12 6.47199L18.763 19.999H5.23601ZM11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V12ZM13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg003Alert);
export default __webpack_public_path__ + "static/media/003-alert.ea9db782537168aa0a41e031259f71d4.svg";
export { ForwardRef as ReactComponent };